























import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/components/shared/Layout.vue';
import UserAccountBody from '@/components/user/UserAccountBody.vue';

@Component({
  components: {
    Layout,
    UserAccountBody,
  },
})
export default class UserAccount extends Vue {}
